export default __webpack_public_path__ + "static/media/sweet-3.badeecbe.jpg";